<div class="modal-overlay">
    <div class="card mx-auto border-0">
        <div class="card-header bergh-bg-primary text-white h5">
            Brandpartities toevoegen
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <span class="size">Je kunt geen brandpartitie toevoegen buiten de zone <br />
                        Probeer de brandpartitie binnen de zone toe te voegen.</span>
                </div>
            </div>
        </div>
        <div class="card-footer bg-white d-flex justify-content-end">
            <button class="btn btn-secondary mr-2" (click)="cancel.emit()" id="btn-cancel">Ok</button>

        </div>
    </div>
</div>
